import React from 'react';
import { Icon } from 'elements';

const Copyright = ({size, className}) => (
  <Icon size={size} className={className}>
    <path d="M10.08,10.86c0.05-0.33,0.16-0.62,0.3-0.87s0.34-0.46,0.59-0.62c0.24-0.15,0.54-0.22,0.91-0.23
      c0.23,0.01,0.44,0.05,0.63,0.13c0.2,0.09,0.38,0.21,0.52,0.36s0.25,0.33,0.34,0.53s0.13,0.42,0.14,0.64h1.79
      c-0.02-0.47-0.11-0.9-0.28-1.29s-0.4-0.73-0.7-1.01S13.66,8,13.24,7.84s-0.88-0.23-1.39-0.23c-0.65,0-1.22,0.11-1.7,0.34
      s-0.88,0.53-1.2,0.92s-0.56,0.84-0.71,1.36S8,11.29,8,11.87v0.27c0,0.58,0.08,1.12,0.23,1.64s0.39,0.97,0.71,1.35
      s0.72,0.69,1.2,0.91c0.48,0.22,1.05,0.34,1.7,0.34c0.47,0,0.91-0.08,1.32-0.23s0.77-0.36,1.08-0.63s0.56-0.58,0.74-0.94
      s0.29-0.74,0.3-1.15h-1.79c-0.01,0.21-0.06,0.4-0.15,0.58s-0.21,0.33-0.36,0.46s-0.32,0.23-0.52,0.3c-0.19,0.07-0.39,0.09-0.6,0.1
      c-0.36-0.01-0.66-0.08-0.89-0.23c-0.25-0.16-0.45-0.37-0.59-0.62s-0.25-0.55-0.3-0.88s-0.08-0.67-0.08-1v-0.27
      C10,11.52,10.03,11.19,10.08,10.86z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8
      s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z"/>
  </Icon>
);

export default Copyright;



// WEBPACK FOOTER //
// ./src/core/icons/components/Copyright.jsx